import React, { ReactNode } from 'react';
import { Breadcrumb, BreadcrumbSeparator, BreadcrumbItem, BreadcrumbList } from "components/ui/breadcrumb";
import { Icon } from "components/ui/icon";
import { Link, useLocation } from "react-router-dom"; // Import from react-router-dom

interface SiteBreadcrumbProps {
    children?: ReactNode;
    customName?: string; // New optional prop for the custom name
}

const SiteBreadcrumb = ({ children, customName }: SiteBreadcrumbProps) => {
    // Use useLocation hook to get the current pathname
    const location = useLocation();

    // Split the pathname into an array of path segments, filtering out empty strings
    const locations = location.pathname.split('/').filter(path => path);

    return (
        <div className="flex justify-between gap-3 items-center mb-6">
            <div className="flex-1">
                <Breadcrumb>
                    <BreadcrumbList>
                        {/* Home icon breadcrumb item */}
                        <BreadcrumbItem>
                            <Link to="/">
                                <Icon icon="heroicons:home" className="h-5 w-5" />
                            </Link>
                        </BreadcrumbItem>

                        {/* Breadcrumb separator */}
                        <BreadcrumbSeparator />

                        {/* Dynamic breadcrumb items based on the current location */}
                        {
                            locations.map((link, index) => {
                                // Generate the href for each breadcrumb item based on the path segments
                                const href = `/${locations.slice(0, index + 1).join('/')}`;
                                const itemLink = link;
                                const isLast = index === locations.length - 1; // Check if it's the last breadcrumb item

                                return (
                                    <React.Fragment key={index}>
                                        <BreadcrumbItem className="capitalize">
                                            {/* If it's the last item, render it as plain text; otherwise, wrap it in a Link */}
                                            {isLast ? (
                                                <>
                                                    {itemLink}
                                                    {customName && (
                                                        <>
                                                            <BreadcrumbSeparator />
                                                            {customName}
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <Link to={href}>{itemLink}</Link>
                                            )}
                                        </BreadcrumbItem>
                                        {/* Render the separator unless it's the last item */}
                                        {locations.length !== index + 1 && <BreadcrumbSeparator />}
                                    </React.Fragment>
                                );
                            })
                        }
                    </BreadcrumbList>
                </Breadcrumb>
            </div>

            {/* Optional children passed as props */}
            <div className="flex-none flex gap-2">{children}</div>
        </div>
    );
};

export default SiteBreadcrumb;
